<mat-form-field class="lvr-search" appearance="fill">
	<mat-icon matPrefix>search</mat-icon>
	<input
		matInput
		placeholder="Suche"
		[value]="value()"
		type="search"
		(input)="onUserInput($event)"
		[attr.aria-label]="ariaLabel()"
	/>
</mat-form-field>
